import React, { Component } from 'react'
import { Link } from 'react-router-dom' 
import codeyolo from '../../assets/img/codeyolo.png'
export default class Footer extends Component {

  render() {
    return (
      <div className='footer'>
        <div className='nameHolder'>
          <Link to="/">
            {/* <h1 className='-mr-10 -mb-5 Name-footer'>C <img className='icon-footer' src='http://blog.codepen.io/wp-content/uploads/2012/06/Button-White-Large.png' alt='' /> D E Y O L O</h1> */}
            <img src={codeyolo} style={{
              width : 150,
              height : 150
            }} alt="codeyolo" />
          </Link>
          <p className='Clonpen -mt-30'>2021 CodeYolo</p>
          {/* <p className='demo -mt-3'>Dev Mohib</p> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js